export enum Typeables {
  activities = 'activities',
}
